import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '..';

import './style.scss';

export default function ButtonRow(props) {
	const { label, label1, disableSave, handleButtonClick, right, paddingTop } = props;
	// make lable as null when u want to hide it -- Mathew
	return (
		<>
			<div style={paddingTop && { paddingTop }} className={classNames({ button__row: true, 'button__row--right': right })}>
				<div className='button__row--button'>{label !== 'None' && <Button primary compact transparent label={label} handleOnSubmit={() => handleButtonClick(label)} />}</div>
				<Button primary compact label={label1} disabled={disableSave} handleOnSubmit={() => handleButtonClick(label1)} />
			</div>
		</>
	);
}

ButtonRow.propTypes = {
	label: PropTypes.string,
	label1: PropTypes.string,
	handleButtonClick: PropTypes.func
};

ButtonRow.defaultProps = {
	label: '',
	label1: '',
	handleButtonClick: () => {}
};
